/*
 *
 * File JS per la Homepage
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// Global components
//--------------------------------------------------------------------//

import hero from "../../components/hero/hero";
import textContent from "../../components/textContent/textContent";
import services from "../../components/services/services";
import bannerClients from "../../components/bannerClients/bannerClients";
import bannerTextAndImage from "../../components/BannerTextAndImage/bannerTextAndImage";
import sliderCards from "../../components/sliderCards/sliderCards";
import ecoBanner from "../../components/ecoBanner/ecoBanner";
import sliderAwards from "../../components/sliderAwards/sliderAwards";
import banner from "../../components/banner/banner";
//--------------------------------------------------------------------//

// Stile pagina
//--------------------------------------------------------------------//
import "./homepage.scss";
import servicesList from "../../components/servicesList/servicesList";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
hero();
services();
sliderCards();
sliderAwards();
ecoBanner();

//--------------------------------------------------------------------//
